import { Navigate } from 'react-router-dom';
import { useTabNavigation } from '../../store/mainTabsStore';
import { useAuth } from '../../store/authAtom';

function NotFoundRoute() {
  const { authState } = useAuth();
  const { makeTabActive } = useTabNavigation();

  if (!Boolean(authState.user)) {
    return <Navigate to="/sign-in" />;
  } else {
    setTimeout(() => makeTabActive('/'), 100);
  }
}

export default NotFoundRoute;
